import React from 'react'
import HTag from '@/lib/HTag'
import ProgramStatic from './ProgramStatic'

const ProgramListStatic = ({ heading, programs, pattern }) => (
	<section className={pattern}>
		<div className="section text-center">
			<HTag className="h1" {...heading} />

			<ul className="carousel gap-8 <md:gap-4 mt-8">
				{programs?.map((program, key) => (
					<li key={key}>
						<ProgramStatic {...program} />
					</li>
				))}
			</ul>
		</div>
	</section>
)

export default ProgramListStatic
